import { InjectionToken } from '@angular/core';

export const API_SERVER_URL = new InjectionToken<string>('API_SERVER_URL');
export const API_GRAPHQL_ENDPOINT = new InjectionToken<string>('API_GRAPHQL_ENDPOINT');
export const API_SUBSCRIPTION_ENDPOINT = new InjectionToken<string>('API_SUBSCRIPTION_ENDPOINT');
